import React, { useEffect, useState } from "react";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "antd/dist/antd.min.css";
import { Route, Routes } from "react-router-dom";
import SiderLayout from "../src/Components/Layout/index";
import ForgotPassword from "./pages/auth/ForgotPassword";
import UsersListView from "./pages/users/list";
import Login from "./pages/login";
import ResetPassword from "./pages/auth/ResetPassword";
import UserInviteView from "./pages/users/invite";
import InvitationListView from "./pages/invitation/list";
import LeavesListView from "./pages/leaves/List";
import MyLeavesView from "./pages/myLeaves/List";
import ApplyLeaves from "./pages/leaves/Apply";
import LeaveSummary from "./pages/LeaveSummary/LeaveSummary";
import Dashboard from "./pages/Dashboard/Dashboard";
import Profile from "./pages/users/profile";
import "./index.css";
import { Provider, useDispatch, useSelector } from "react-redux";
import { store } from "./redux/store";
import ChangePassword from "./pages/changePassword";
import ProtectedRoute from "./pages/auth/ProtectedRoute";
import Allemployee from "./pages/employee/Allemployee";
import EmployeeLeaves from "./pages/employee/EmployeeLeaves";
// import Account from "./pages/account/EmployeeSalary";
// import Allowance from "./pages/account/Allowance";
// import AddAllowance from "./pages/account/AddAllowance";
// import TdsCalculation from "./pages/account/TdsCalculation";
// import AddTdscalculation from "./pages/account/AddTdscalculation";
// import UpadteTdsCalculation from "./pages/account/updateTdsCalculation";
import CompanyPolicy from "./pages/companyPolicy/CompanyPolicy";
import "./App.css";
import EmailVerification from "./pages/auth/EmailVerification";
import Holidays from "./pages/SpectusHolidays";
import CompanyPolicyuserlist from "./pages/companyPolicy/CompanyPolicyuserlist";
import AddEmployee from "./pages/employee/AddEmployee";
import UpdateEmployee from "./pages/employee/updateEmployee";
import NotFound from "./pages/notFound/NotFound";
import UnProtectedRoute from "./pages/auth/UnProtetedRoutes";
import AdminRoute from "./pages/auth/AdminRoute";
import EmployeeRoutes from "./pages/auth/EmployeeRoutes";
// import AddSalaryDetails from "./pages/employee/AddSalaryDetails";
import Attendance from "./pages/attendance/Attendance.js";
import Availability from "./pages/availability/Availability.js";
import { fetchUserData } from "./redux/slice/userData.js";
import EmployeeCompanyPolicy from "./pages/employeeCompanyPolicy/EmployeeCompanyPolicy.js";
import NewUser from "./pages/newUser/NewUser.js";
import CryptoJS from 'crypto-js';
import ViewEmployee from "./pages/employee/ViewEmployee.js";
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard.js";

const { default: env } = require("./config/env.js");


function App() {
  const [showMobileWarning, setShowMobileWarning] = useState(false);
  const dispatch = useDispatch();
  const secretKey = 'YourSecretKey';
  const state = useSelector((state) => state);
  const token = useSelector((state) => state.auth.token);
  let userData = useSelector((state) => state.auth.userData)
  let Roles = userData?.role_id;

  useEffect(() => {
    if (window.innerWidth <= 980) {
      setShowMobileWarning(true);
    }
  }, []);
  return (
    <>
      <BrowserRouter basename={env.baseName}>
        {!showMobileWarning ? (
          <Routes>
            <Route path="newuser/:userToken" element={<NewUser />} />
            <Route element={<UnProtectedRoute />}>
              <Route
                path="email-verification"
                element={<EmailVerification />}
              />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/login" element={<Login />} />
            </Route>
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<SiderLayout role={Roles} />}>
                {Roles &&
                  <>
                    {Roles === 3 && (
                      <>
                        <Route
                          exact
                          path="/"
                          element={<AdminDashboard role={Roles} />}
                        />
                        <Route
                          exact
                          path="/allemployee"
                          element={<Allemployee role={Roles} userData={userData} />}
                        />
                        <Route
                          exact
                          path="/addemployee"
                          element={<AddEmployee />}
                        />
                        <Route
                          exact
                          path="/updateemployee"
                          element={<UpdateEmployee />}
                        />
                        <Route
                          exact
                          path="/viewemployee"
                          element={<ViewEmployee />}
                        />
                        <Route
                          exact
                          path="/employeeleave"
                          element={<EmployeeLeaves userData={userData} />}
                        />
                        <Route
                          exact
                          path="/employeeavailability"
                          element={<Availability />}
                        />
                        {/* <Route exact path="/account" element={<Account />} />
                    <Route exact path="/allowance" element={<Allowance />} />
                    <Route
                      exact
                      path="/addallowance"
                      element={<AddAllowance />}
                    />
                    <Route
                      exact
                      path="/tds-calculation"
                      element={<TdsCalculation />}
                    />
                    <Route
                      exact
                      path="/addTdscalculation"
                      element={<AddTdscalculation />}
                    /> */}
                        {/* <Route
                      exact
                      path="/updattdscalculation"
                      element={<UpadteTdsCalculation />}
                    /> */}
                        {/* <Route
                      exact
                      path="/add-salary-details"
                      element={<AddSalaryDetails />}
                    /> */}
                        <Route
                          exact
                          path="/companypolicy"
                          element={<CompanyPolicyuserlist />}
                        />
                        <Route
                          exact
                          path="/companypolicy/updatecompanypolicy"
                          element={<CompanyPolicy userData={userData} />}
                        />
                        <Route exact path="/users" element={<UsersListView />} />
                      </>
                    )}
                    <Route
                      exact
                      path="/profile"
                      element={<Profile userData={userData} />}
                    />
                    <Route
                      exact
                      path="/users/invite"
                      element={<UserInviteView />}
                    />
                    <Route
                      exact
                      path="/invitations"
                      element={<InvitationListView />}
                    />
                    <Route exact path="/leaves" element={<LeavesListView />} />
                    {Roles !== 3 && (
                      <>
                        <Route exact path="/" element={<Dashboard userData={userData} />} />
                        <Route
                          exact
                          path="/myleaves"
                          element={
                            <MyLeavesView role={Roles} userData={userData} />
                          }
                        />
                        <Route
                          exact
                          path="/myleaves/applyleave"
                          element={<ApplyLeaves role={Roles} userData={userData} />}
                        />
                        <Route
                          exact
                          path="/myleaves/leavesummary"
                          element={<LeaveSummary userData={userData} />}
                        />
                        <Route exact path="/attendance" element={<Attendance userData={userData} />} />
                        <Route
                          exact
                          path="/employeeCompanypolicy"
                          element={<EmployeeCompanyPolicy role={Roles} />}
                        />
                      </>
                    )}
                    <Route
                      exact
                      path="/changePassword"
                      element={<ChangePassword userData={userData} />}
                    />
                    <Route
                      exact
                      path="/spectusholidays"
                      element={<Holidays role={Roles} />}
                    />
                    <Route path="*" element={<NotFound />} />
                  </>}
              </Route>

            </Route>
          </Routes>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "95vh",
            }}
          >
            Mobile View Not supported
          </div>
        )}
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
